var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 231,
    viewBox: "0 0 176 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54177_631)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -6,
    width: 177,
    height: 264,
    rx: 5,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.7364,
    cy: 101.834,
    rx: 14.3341,
    ry: 14.3341,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 136.104C63.9962 135.097 64.2216 134.101 64.6591 133.193C66.0321 130.447 69.9039 128.992 73.1168 128.333C75.4338 127.839 77.7829 127.508 80.1465 127.344C84.5225 126.96 88.9238 126.96 93.2998 127.344C95.6632 127.51 98.0122 127.84 100.33 128.333C103.542 128.992 107.414 130.31 108.787 133.193C109.667 135.044 109.667 137.192 108.787 139.042C107.414 141.926 103.542 143.244 100.33 143.875C98.0152 144.39 95.6653 144.73 93.2998 144.891C89.7381 145.193 86.1598 145.248 82.5904 145.056C81.7666 145.056 80.9703 145.056 80.1465 144.891C77.7899 144.732 75.449 144.392 73.1442 143.875C69.9039 143.244 66.0595 141.926 64.6591 139.042C64.2238 138.124 63.9987 137.12 64 136.104Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54177_631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 231,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/Picture.78ce2bede3ba3f14b3e3159a3b21ca4a.svg";
export { ForwardRef as ReactComponent };